import type { AppRoute } from '@/contexts/NavigationContext'

export type NavIconName =
  | 'markets'
  | 'trade'
  | 'portfolio'
  | 'orders'
  | 'deposit'
  | 'withdraw'
  | 'calendar'
  | 'news'
  | 'copy'
  | 'analysis'
  | 'settings'

export interface NavItem {
  id: AppRoute
  labelKey: string
  icon: NavIconName
}

/** Primary routes for mobile bottom bar (includes Markets). */
export const PRIMARY_NAV: NavItem[] = [
  { id: 'markets', labelKey: 'nav.markets', icon: 'markets' },
  { id: 'trade', labelKey: 'nav.trade', icon: 'trade' },
  { id: 'portfolio', labelKey: 'nav.portfolio', icon: 'portfolio' },
  { id: 'orders', labelKey: 'nav.orders', icon: 'orders' },
]

/** Desktop sidebar primary routes — Markets lives beside the chart instead. */
export const DESKTOP_PRIMARY_NAV: NavItem[] = [
  { id: 'trade', labelKey: 'nav.trade', icon: 'trade' },
  { id: 'portfolio', labelKey: 'nav.portfolio', icon: 'portfolio' },
  { id: 'orders', labelKey: 'nav.orders', icon: 'orders' },
]

/** Feature / funding / research items (desktop sidebar + mobile drawer). */
export const FEATURE_NAV: NavItem[] = [
  { id: 'deposit', labelKey: 'sidebar.deposit', icon: 'deposit' },
  { id: 'withdraw', labelKey: 'sidebar.withdraw', icon: 'withdraw' },
  {
    id: 'economic_calendar',
    labelKey: 'sidebar.economic_calendar',
    icon: 'calendar',
  },
  { id: 'news', labelKey: 'sidebar.news', icon: 'news' },
  { id: 'copy_trade', labelKey: 'sidebar.copy_trade', icon: 'copy' },
  { id: 'analysis', labelKey: 'sidebar.analysis', icon: 'analysis' },
]

export const SECONDARY_NAV: NavItem[] = [
  { id: 'settings', labelKey: 'nav.settings', icon: 'settings' },
]
